module.exports = __webpack_public_path__ + "static/media/antidote-medical-tablets-svgrepo-com.209d20ba.svg";